import { SkeletonPlaceholder } from '@carbon/react';

import styles from './WideSkeleton.module.scss';

const WideSkeleton = () => <SkeletonPlaceholder className={styles.skeleton} />;

export default WideSkeleton;
